export default __webpack_public_path__ + "static/media/Access-Health-Support_290x170.595312b8.jpg";